import TableCardsSorting from '@rio-cloud/rio-uikit/TableCardsSorting';
import TableViewToggles from '@rio-cloud/rio-uikit/TableViewToggles';
import type { JSX } from 'react';
import { FormattedMessage } from 'react-intl';

import type { TableColumn } from '../../enums/TableColumn';
import { getColumnHeaderMessageId } from './columnHeaderFormattingService';
import type { TableCardsSortingHeaderProps } from './types';

export const TableCardsSortingHeader = (props: TableCardsSortingHeaderProps): JSX.Element => {
    const { sortBy, sortDir, viewType, columns, onSortChange } = props;

    const cardSortingSelectOptions = columns.map(column => ({
        id: column,
        label: <FormattedMessage id={getColumnHeaderMessageId(column)} />,
        selected: column === sortBy,
        disabled: false,
    }));

    return (
        <div>
            {sortBy && viewType && viewType !== TableViewToggles.VIEW_TYPE_TABLE && (
                <TableCardsSorting
                    selectOptions={cardSortingSelectOptions}
                    sortName={sortBy}
                    sortOrder={sortDir}
                    onSortChange={(name, order) => onSortChange(name as TableColumn, order)}
                />
            )}
        </div>
    );
};
